import { TrackPlayback } from '../../../TrackGrid';
import {
  StyledIconButton,
  StyledPauseButton,
  StyledPauseIcon,
  StyledPlayIcon,
} from './styled';

interface PlayButtonProps {
  isPlaying: boolean;
  play: () => void;
  pause: () => void;
}

const PlayButton = ({ isPlaying, play, pause }: PlayButtonProps) => (
  <TrackPlayback>
    {isPlaying ? (
      <StyledPauseButton onClick={pause}>
        <StyledPauseIcon />
      </StyledPauseButton>
    ) : (
      <StyledIconButton onClick={play}>
        <StyledPlayIcon />
      </StyledIconButton>
    )}
  </TrackPlayback>
);

export default PlayButton;
